import React, { useState, useEffect } from 'react';
import './MultiSlider.css';

export interface SliderOption {
  id: string;
  label: string;
  emoji: string;
  explanation: string;
}

interface MultiSliderProps {
  type: string;
  options: SliderOption[];
  onChange?: (option: SliderOption | 'ALL') => void;
}

export const MultiSlider: React.FC<MultiSliderProps> = ({ type, options, onChange }) => {
  const fullOptions = [{ id: 'all', emoji: 'ALL' }, ...options];

  const categoryToIndex = (savedCategory: string | null, options: SliderOption[]) => {
    if (!savedCategory || savedCategory === 'ALL') return 0;

    const index = options.findIndex((c) => c.id === savedCategory);
    return index === -1 ? 0 : index + 1;
  };

  const [index, setIndex] = useState(0);

  useEffect(() => {
    var savedCategory: string | null = 'ALL';
    if (type === 'sightseeing') {
      savedCategory = localStorage.getItem('travel_category');
    } else if (type === 'food') {
      savedCategory = localStorage.getItem('food_category');
    } else if (type === 'region') {
      savedCategory = localStorage.getItem('travel_region');
    }

    const idx = categoryToIndex(savedCategory, options);
    setIndex(idx);
  }, [options, type]); // IMPORTANT

  const handleSelect = (i: number) => {
    setIndex(i);

    if (i === 0) {
      onChange?.('ALL');
    } else {
      onChange?.(options[i - 1]);
    }
  };

  return (
    <div className="multi-slider-container">
      <div className="multi-slider-track">
        <div
          className="multi-slider-thumb"
          style={{
            width: `${100 / fullOptions.length}%`,
            transform: `translateX(${index * 100}%)`,
          }}
        >
          <div className="thumb-circle"></div>
        </div>

        {fullOptions.map((p, i) => (
          <div key={p.id} className="emoji-slot" style={{ width: `${100 / fullOptions.length}%` }} onClick={() => handleSelect(i)}>
            <span className={`emoji ${p.id === 'all' ? 'all-option' : ''} ${i === index ? 'active' : ''}`}>{p.emoji}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
